
























































































































































































































































import DragUpload from '@/components/util/DragUpload.vue';
import PropertyPicker from '@/components/system/PropertyPicker.vue';
import OrderAssetListComponent from '@/components/orders/OrderAssetListComponent.vue';
import WorkerPicker from '@/components/workers/WorkerPicker.vue';
import DetailLayout from '@/components/system/DetailsLayout.vue';
import FloorPicker from '@/components/system/FloorPicker.vue';
import Location2Picker from '@/components/system/Location2Picker.vue';
import ContactPicker from '@/components/system/ContactPicker.vue';

import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  SystemApi,
  ValueListItem,
  WorkordersApi,
  UsersApi,
  Workorder,
  User as PmoUser,
  ValidationProblemDetails,
  PerformoSettings,
  Property,
  Asset,
  AssetsApi,
  Contact,
  GetAssetRequest
} from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {
    DragUpload,
    PropertyPicker,
    OrderAssetListComponent,
    WorkerPicker,
    DetailLayout,
    FloorPicker,
    Location2Picker,
    ContactPicker
  },
  computed: mapGetters({
    settings: 'settings',
    currentProperty: 'currentProperty',
    assetsApi: 'assetsApi',
    wkoApi: 'ordersApi'
  })
})
export default class Create extends Vue {
  private settings!: PerformoSettings;
  private currentProperty!: Property;

  private sys = new SystemApi(this.$store.getters.getApiConfiguration);
  private usersApi = new UsersApi(this.$store.getters.getApiConfiguration);
  private assetsApi!: AssetsApi;
  private wkoApi!: WorkordersApi;

  private query!: GetAssetRequest;

  private selectedContact: Contact = {};

  jobTypes: ValueListItem[] = [];
  priorities: ValueListItem[] = [];
  selectedAssets: Asset[] = [];

  hasPhoto = false;
  currentPerformoUserAndContact: PmoUser = { contact: {} };

  get currentUserName(): string {
    return this.$store.getters.userDisplayName;
  }
  get currentPropertyId(): string {
    return this.$store.getters.currentPropertyId;
  }

  private createOrderWatcher = false;
  private order: Workorder = {
    propertyId: this.currentPropertyId,
    building: undefined,
    floor: undefined,
    suite: undefined
  };
  private validationProblems: ValidationProblemDetails = {};

  private async mounted() {
    this.currentPerformoUserAndContact = await this.usersApi.getMyProfile();
    if (
      this.currentPerformoUserAndContact &&
      this.currentPerformoUserAndContact.contact
    ) {
      this.order.building =
        this.currentPerformoUserAndContact.contact.location1;
      this.order.suite = this.currentPerformoUserAndContact.contact.location2;
      this.order.floor = this.currentPerformoUserAndContact.contact.floor;
    }

    // if creating an order from the asset detail view, add asset to pending Order
    if (Object.keys(this.$route.query).length > 0) {
      this.query = {
        assetId: parseInt(this.$route.query['assetId'] as string)
      };

      if (this.query.assetId) {
        const pickedAsset = await this.assetsApi.getAsset(this.query);
        this.selectedAssets.push(pickedAsset);
      }
    }

    // run the initial load
    await this.loadOrderCreate();
  }

  @Watch('order.propertyId', { deep: true })
  private async loadOrderCreate() {
    // refresh things if/when property is changed.

    if (this.order.propertyId) {
      this.jobTypes = await this.sys.getValueListItems({
        propertyId: this.order.propertyId,
        name: 'Job Types'
      });
      this.priorities = await this.sys.getValueListItems({
        propertyId: this.order.propertyId,
        name: 'Priority'
      });
    }
  }

  private successHandler(order: Workorder) {
    // add assets to order before routing to detail view
    if (order && order.workorderId) {
      this.selectedAssets.forEach(async (asset) => {
        if (asset.assetId) {
          await this.wkoApi.addAssetToOrder({
            workorderAssetCreateCommand: {
              workorderId: order.workorderId,
              assetId: asset.assetId
            }
          });
        }
      });

      this.$router.push({
        name: 'work-order-detail',
        params: { id: order.workorderId }
      });
    }
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    if (error instanceof Response) {
      error = await error.json();
    }

    this.validationProblems = error;

    // scroll the error div into view on a delay
    setTimeout(() => {
      const el = document.getElementById('error-display');
      if (el) {
        el.scrollIntoView(true);
      }
    }, 100);
  }

  private fileAddedHandler() {
    this.hasPhoto = true;
  }

  private async createRequest() {
    // if a file is attached, we have to use the upload er to do the upload as well as the form submission
    // otherwise we hit the api directly.
    if (this.hasPhoto) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this.$refs.dragUpload as any).processUploadQueue();
    } else {
      const wkoApi = new WorkordersApi(this.$store.getters.getApiConfiguration);
      wkoApi
        .createWorkOrder({ workorderCreateCommand: this.order })
        .then(this.successHandler, this.errorHandler);
    }
  }

  private updateSelectedAssets(assets: Asset[]) {
    assets.forEach((asset) => {
      // filter out duplicates
      const found = this.selectedAssets.some(
        (a) => a.assetId === asset.assetId
      );
      if (!found) {
        this.selectedAssets.push(asset);
      }
    });
  }

  private updateSelectedContact(contact: Contact) {
    if (contact) {
      this.selectedContact = contact;
    } else {
      this.selectedContact = {};
    }
  }
}
